import { useQuery } from "react-query"
import qs from "query-string"

import { apiRequest } from "util/request"

/** ------------------- **/
/*  Market Insights
/** ------------------- **/

export function useMarketInsights({
  terms,
  startDate,
  endDate,
}: {
  terms: string[]
  startDate?: string
  endDate?: string
}) {
  const cacheKey = ["marketInsights", terms, startDate, endDate]
  const paramString = qs.stringify({
    terms: terms.join(","),
    // start_date: startDate,
    // end_date: endDate,
  })
  const query = () => apiRequest(`market_insights/explore?${paramString}`)
  return useQuery(cacheKey, query, {
    enabled: !!terms?.length,
  })
}

export function useMarketInsightsTerms() {
  const cacheKey = ["marketInsightsTerms"]
  const query = () => apiRequest("market_insights/terms")
  return useQuery(cacheKey, query)
}

export function useMarketInsightsTrends() {
  const cacheKey = ["marketInsightsTrends"]
  const query = () => apiRequest("market_insights/trends")
  return useQuery(cacheKey, query)
}

export function useMarketInsightsAll() {
  const cacheKey = ["marketInsightsAll"]
  const query = () => apiRequest("market_insights/all")
  return useQuery(cacheKey, query)
}
